import React from 'react';
import { connect } from 'react-redux';
import Currencies from '../../../../constants/currencies';
import exchangeRateContainer from '../../../../containers/exchange-rate';

class ExchangeRateInput extends React.Component {
  constructor(props) {
    super(props);
    this.changeExchangeRate = this.changeExchangeRate.bind(this);

    this.state = {
      exchangeRate: props.exchangeRate.exchangeRate
    };
  }

  async componentDidMount() {
    const {
      changeValue, fetchExchangeRate, currency, exchangeRate, harcirahId
    } = this.props;

    await fetchExchangeRate(currency);

    const currentExchangeRate = exchangeRate.exchangeRate;

    changeValue({
      exchangeRate: currentExchangeRate.replace(',', '.'),
      harcirahId,
    });
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.exchangeRate.exchangeRate !== this.props.exchangeRate.exchangeRate) {
      this.setState({ exchangeRate: this.props.exchangeRate.exchangeRate.replace(',', '.') });
    }
  }


  changeExchangeRate(e) {
    const exchangeRate = e.target.value.replace(',', '.');
    this.setState({ exchangeRate });
    this.props.changeValue({ exchangeRate });
  }


  render() {
    const { currency } = this.props;

    return (
      <div className="content table-responsive table-full-width">
        <table className="table table-hover table-bordered">
          <tbody>
            <tr>
              <td>
                            NOT:
                {' '}
              </td>
              <td>
                <span style={{ fontSize: '12px' }}>
                    Güncel
                  {' '}
                  {' '}
                  <strong>
                    Türkiye Cumhuriyet Merkez Bankası
                  </strong>
                  {' ` '}
                    ndaki kur çekilmiştir.
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <span style={{ textTransform: 'uppercase' }}>
                  {currency}
                </span>
                {' '}
                            (
                {Currencies(currency)}
                            )
              </td>
              <td>
                <input
                  type="text"
                  style={{ width: '70%' }}
                  onChange={this.changeExchangeRate}
                  value={this.state.exchangeRate}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default connect(...exchangeRateContainer)(ExchangeRateInput);



// WEBPACK FOOTER //
// ./src/components/actions/exchange-rate/component/index.js